/* eslint-disable react/prop-types */
import React, {
    useState, useCallback, useEffect, useMemo,
} from 'react';
import classNames from 'classnames';
import { Portal } from 'react-portal';

import { VideoModal } from '../VideoModal/VideoModal';
import { slidesConfig } from './videoSliderConfig';


const VideoSlider = ({ activeSlideId, setActiveSlideId }) => {
    const selectedVideo = useMemo(
        () => {
            if (!activeSlideId) return null;
            return slidesConfig.find((e) => e.id === activeSlideId);
        },
        [activeSlideId],
    );

    const handleCloseVideo = useCallback(
        () => {
            setActiveSlideId(null);
        },
        [setActiveSlideId],
    );

    const rootClasses = classNames({
        'hochland-selection-slider-root': true,
    });
    return (
        <div className={rootClasses}>
            {selectedVideo && (
                <VideoModal
                    video={selectedVideo}
                    handleClose={handleCloseVideo}
                />
            )}
        </div>
    );
};


export const VideoSliderPortalGlobal = React.memo((props) => {
    const { selector = 'video-slider-portal-new' } = props;

    const [activeSlideId, setActiveSlideId] = useState(null);
    const sliderRootNode = document.getElementById(selector);

    const handleClickSliderCard = (e) => {
        const { target } = e;
        const cardId = target.dataset.card_id;
        setActiveSlideId(cardId);
    };

    useEffect(
        () => {
            sliderRootNode?.addEventListener('click', handleClickSliderCard);
            return () => {
                sliderRootNode?.removeEventListener('click', handleClickSliderCard);
            };
        },
        [sliderRootNode],
    );

    if (!sliderRootNode) {
        return null;
    }

    return (
        <Portal node={sliderRootNode}>
            <VideoSlider
                activeSlideId={activeSlideId}
                setActiveSlideId={setActiveSlideId}
            />
        </Portal>
    );
});
